<template>
  <v-row class="w-100 w-full" justify="center">
    <v-col cols="12" sm="6" md="5" lg="4">
      <v-sheet
        color="white"
        elevation="4"
        outlined
        rounded
        class="ma-5 pa-6 rounded-lg welcome-page"
      >
        <div class="text-center title">
          <p>{{$_strings.welcomePage.ADMIN}}</p>
        </div>
        <div class="mb-6">
          <span class="headline-6">
            {{$_strings.welcomePage.COME_IN}}
          </span>
        </div>
        <v-form ref="loginForm" @submit.prevent="login">
          <v-text-field
            v-model="email"
            ref="email"
            :label="$_strings.welcomePage.EMAIL"
            clearable
            dense
            :rules="rules.email"
            class="body-2"
            :hint="emailHint"
            persistent-hint
            :readonly="isReadonly"
            @focus="fucosEmail"
            @blur="blurEmail"
          >
          </v-text-field>
          <v-text-field
            ref="password"
            v-model="password"
            :label="$_strings.welcomePage.PASSWORD"
            class="body-2 mb-8 mt-4"
            dense
            :type="passwordShow ? 'text' : 'password'"
            :rules="rules.password"
            :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="passwordShow = !passwordShow"
          ></v-text-field>
          <v-btn rounded large class="background-denim white--text font-weight-bold body-2 w-100" type="submit">
            {{$_strings.welcomePage.LOGIN}}
          </v-btn>
        </v-form>
        <div class="d-flex ma-0 mt-6 justify-center body-2 grey--text">
          <p class="text-scorpion" >{{$_strings.welcomePage.CREATE_ACCOUNT}} <router-link to="form-registration">{{$_strings.welcomePage.REGISTER}}</router-link></p>
        </div>
      </v-sheet>
    </v-col>
    <v-footer class="d-flex justify-end">
      <p>Copyright &copy; 2019 - {{yearNow}} <a target="_blank" href="http://">fastlog.id</a>, All Rights Reserved. </p>
    </v-footer>
  </v-row>
</template>

<script>

export default {
  name: 'Login-form',
  data() {
    return {
      yearNow: new Date().getFullYear(),
      email: '',
      password: '',
      passwordShow: false,
      emailHint: '',
      rulesEmail: [
        (value) => {
          if (!value) {
            return this.$_strings.messages.validation.REQUIRED('Email');
          }
          return this.isEmailValid(value) || this.$_strings.messages.validation.EMAIL;
        },
      ],
      rules: {
        email: [],
        password: [
          (v) => {
            if (v) {
              return !!v;
            }
            return this.$_strings.messages.validation.REQUIRED('Password');
          },
        ],
      },
      isReadonly: true,
    };
  },
  computed: {
    loginForm() {
      return {
        email: this.email,
        password: this.password,
      };
    },
  },
  methods: {
    navigateToPageMain() {
      if (this.$store.getters['auth/isLoggedIn']) {
        const menu = JSON.parse(this.$store.getters['auth/menu']);
        if (menu[0].child.length > 0) {
          this.$router.replace(menu[0].child[0].url);
          return;
        }
        this.$router.replace(menu[0].url);
      }
    },
    async login() {
      this.rules.email = this.rulesEmail;
      this.email = this.email && this.email.trim();
      this.$nextTick(async () => {
        const valid = this.$refs.loginForm.validate();
        if (valid && this.rules.email.length) {
          try {
            this.$root.$loading.show();
            await this.$store.dispatch('auth/login', this.loginForm);
          } finally {
            this.$root.$loading.hide();
            this.navigateToPageMain();
          }
        }
      });
    },
    fucosEmail() {
      this.isReadonly = false;
      this.rules.email = [];
    },
    blurEmail() {
      this.email = this.email && this.email.trim();
      this.rules.email = this.rulesEmail;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title{
  color: $--color-doveGray;
  font-size: 16px !important;
}
.v-footer {
  background: none;
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>
